import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ProductLabel from './ProductLabel';
import IconDiscontinued from '../../IconDiscontinued';
import { DISCONTINUED, REPLACEMENT } from '../../../../consts';

import styles from './index.scss';

const suggestionClasses = classNames({
    [styles.product]: true,
    'analytics-product-suggestion': true,
});

const Product = ({ product, translationsMap }) => {
    const { replacement, isDiscontinued } = product;

    return (
        <li
            className={suggestionClasses}
            data-item-name={product.tag}
            data-product-id={product.sku}
        >
            <a href={product.href} className={styles.product__link}>
                <div className={styles.product__imgWrapper}>
                    <img src={product.imgSrc} alt={product.title} className={styles.product__img} />
                </div>
                <div className={styles.product__info}>
                    <div className={styles.product__title}>{product.title}</div>
                    <div className={styles.product__sku}>
                        <span>{product.sku}</span>
                        {isDiscontinued && (
                            <React.Fragment>
                                <ProductLabel
                                    type={DISCONTINUED}
                                    firstElement={() => <IconDiscontinued />}
                                    secondElement={() => translationsMap.Discontinued}
                                />

                                {replacement && (
                                    <ProductLabel
                                        type={REPLACEMENT}
                                        firstElement={() =>
                                            `${
                                                translationsMap['search.fss.recommendedReplacement']
                                            }: `
                                        }
                                        secondElement={() => (
                                            <a href={replacement.href}>{replacement.sku}</a>
                                        )}
                                    />
                                )}
                            </React.Fragment>
                        )}
                    </div>
                </div>
            </a>
        </li>
    );
};

Product.propTypes = {
    product: PropTypes.shape({
        href: PropTypes.string,
        imgSrc: PropTypes.string,
        sku: PropTypes.string,
        title: PropTypes.string,
        isDiscontinued: PropTypes.bool,
        replacement: PropTypes.shape({
            href: PropTypes.string,
            sku: PropTypes.string,
        }),
        tag: PropTypes.string,
    }).isRequired,
    translationsMap: PropTypes.object.isRequired,
};

export default Product;
